import { AppBar, Box, Toolbar, Typography, useTheme } from '@mui/material';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';

export const Header = () => {
	const theme = useTheme();

	return (
		<AppBar
			position="static"
			sx={{
				backgroundColor: theme.palette.background.paper,
				color: theme.palette.primary.main,
				boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				mb: 2,
			}}
			elevation={0}
		>
			<Toolbar>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<SportsTennisIcon sx={{ fontSize: 32, transform: 'rotate(45deg)' }} />
					<Typography variant="h5" component="h1" fontWeight="bold">
						Matchi Finder
					</Typography>
				</Box>
			</Toolbar>
		</AppBar>
	);
};
